import { render, staticRenderFns } from "./infoDetails.vue?vue&type=template&id=9837c9fc&scoped=true&"
import script from "./infoDetails.vue?vue&type=script&lang=js&"
export * from "./infoDetails.vue?vue&type=script&lang=js&"
import style0 from "./infoDetails.vue?vue&type=style&index=0&id=9837c9fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9837c9fc",
  null
  
)

export default component.exports